// frontend/src/pages/GroupPredictionsPage.jsx
import React from 'react';
import GroupPredictionsPage from '../components/groups/GroupPredictionsPage';

const GroupPredictionsPageWrapper = () => {
  return <GroupPredictionsPage />;
};

export default GroupPredictionsPageWrapper; 